module.exports = __webpack_public_path__ + "static/media/badge_level_5_1.2b94cf2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_5_1.png
// module id = 491
// module chunks = 0